Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.errorTitle = "Error";

exports.apiVerifyOtpContentType = "application/json";
exports.apiVerifyOtpEndPoint =
  "account/accounts/sms_confirmation?pin=";

exports.apiVerifyForgotPasswordOtpEndPoint =
  "forgot_password/otp_confirmation";

exports.apiVerifyOtpMethod = "POST";

exports.errorOtpNotValid = "OTP is not valid.";

exports.btnTxtSubmitOtp = "Submit otp";

exports.placeHolderOtp = "OTP";

exports.labelInfo =
  "We Just sent a 4 digits OTP to phone. Enter your OTP code below.";

exports.submitButtonColor = "#6200EE";

exports.httpPostMethod = "POST"
exports.sendPhonOtpApiEndPoint = "bx_block_forgot_password/send_verification_code"
exports.verifyPhonOtpApiEndPoint = "bx_block_forgot_password/two_factor_otp_verify"

exports.otpVerificationTitle = "OTP Verification"
exports.otpVerificationDescription = "Please enter verification code sent to"
exports.resendOtpText = "Resend OTP"
exports.timeRemainingText = "Time remaining"
exports.submitText = "Submit"
exports.contactUsText = "Contact Us"
exports.contactUsTextMessage = "For any issues with your registered mobile\n number, please"
